<template>
  <!-- 添加问题弹窗 -->
  <el-dialog title=""
    :visible.sync="visible"
    class="open-reward-dialog-components"
    :close-on-click-modal="false"
    :before-close="close"
		:show-close="true"
    width="390px">
			<div slot="title" class="title">选择开奖结果</div>
      <div class="content">
				<div class="padding-b-20">
					<div class="content-title">{{title}}</div>
					<div class="content-radio-panel flex-middle">
						<div class="content-radio flex-middle" :class="{'radio-select':selectIndex===1?true:false}" @click="changeSelectIndex(1)">
							A.{{contentArr[0]}}
						</div>
						<div class="content-radio flex-middle" :class="{'radio-select':selectIndex===2?true:false}" @click="changeSelectIndex(2)">
							B.{{contentArr[1]}}
						</div>
					</div>
					<div class="flex-middle">
						<div class="content-btn flex-middle" @click="commit">确定</div>
					</div>
				</div>
			</div>
  </el-dialog>

</template>

<script>
	import { dayCount } from "@/util/time";
  import { mapState, mapMutations } from "vuex"
  import { post } from "../../util/http";
  export default{
    computed: {
      ...mapState([
        "userInfo",
        "appConfig"
      ])
    },

    data(){
      return {
        visible : false,
				title: "",
				contentArr: ["",""],
				selectIndex : "",
				data:{}
      }
    },
    created(){
			
    },
    destroyed(){
      
    },
    methods: {
      open(item={}){
				let {title="",contentArr=["",""]} = item;
				this.data = item;
				this.visible = true;
				this.title = title;
				this.contentArr = contentArr;
      },
      close(){
        this.visible = false;
				this.title = "";
				this.data = {};
				this.selectIndex = "";
				this.contentArr = ["",""];
      },
			changeSelectIndex(index=0){
				this.selectIndex = index;
			},

			commit(){
				if(this.selectIndex===""){
					this.$message({
						message: '请选择答案',
						type: 'warning'
					});
					return;
				}
				let data = {
					anchor_id : this.userInfo.id,
					g_id : this.data.g_id,
					result: this.selectIndex
				};
				post({
				  url: "/api/guess/settleGuess",
				  data,
				}).then(({ data: { data,status="" } }) => {
					if(status==0){
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.$emit("refresh")
					}else{
						this.$message({
							message: '提交失败',
							type: 'error'
						});
					}
					this.close();
				})
				.catch(err=>{
					console.warn("settleGuess err: ",err);
				})
			}
    }
  }
</script>

<style  scoped lang="stylus">
  .open-reward-dialog-components{
    z-index:1;
    border-radius: 8px;
		.title{
			color : #333333;
			font-size : .16rem;
		}
    .content{
      .content-title{
				font-size : .15rem;
				padding: 0rem .1rem;
			}
			.content-radio-panel{
				margin : 30px 0px;
				.content-radio{
					border: 1px solid #DBDBDB;
					border-radius: 5px;
					width : 130px;
					height : 48px;
					margin : 0px 10px;
					cursor : pointer;
					font-size : .16rem;
					&.radio-select{
						border-color : #02A8A2;
						background: url(../../assets/img/dialog/right-yes.png) no-repeat;
						background-position: right bottom;
						background-size : .15rem auto;
					}
				}
			}
      .content-btn{
				background: linear-gradient(90deg, #29F19C 0%, #02A1F9 100%);
				border-radius: 5px;
				width : 1.3rem;
				height : 35px;
				color : #ffffff;
				margin : .1rem;
				cursor: pointer;
			}
    }

		/deep/{
			.el-dialog__header{
				display : block;
			}
			.el-form-item{
				margin-bottom : 10px;
			}
			.el-input--small .el-input__icon{
				line-height : 40px;
			}
		}

  }
</style>
